/**
 * 选择→修改 子菜单（DESIGN.md §6.2 补充）。
 *
 * 五项都挂 `submenu: '修改'`——复用 menu-model.ts 已有的折叠逻辑，
 * 渲染成「选择→修改→边界/平滑/扩展/收缩/羽化」嵌套弹出菜单。
 *
 * 每项只是弹出一个「输入像素数」对话框，真正的运算（`border`/`smooth`/
 * `expand`/`contract`/`feather`）在 `selection-modify.ts` 里对接引擎——
 * 这里不碰 SelectionMask，只决定弹哪个对话框。
 */
import type { ActionRegistry } from './registry';

export type SelectionModifyKind = 'border' | 'smooth' | 'expand' | 'contract' | 'feather';

export interface SelectionModifyActionDeps {
  /** 打开「输入像素数」对话框，记下这次是哪种修改。 */
  readonly openDialog: (kind: SelectionModifyKind) => void;
}

const SUBMENU = '修改';

export function registerSelectionModifyActions(
  registry: ActionRegistry,
  deps: SelectionModifyActionDeps,
): void {
  const register = (id: string, title: string, order: number, kind: SelectionModifyKind): void => {
    registry.register({
      id,
      title,
      group: '选择',
      section: 1,
      order,
      submenu: SUBMENU,
      enabled: (s) => s.hasSelection,
      run: () => {
        deps.openDialog(kind);
      },
    });
  };

  register('select.modify.border', '边界…', 0, 'border');
  register('select.modify.smooth', '平滑…', 1, 'smooth');
  register('select.modify.expand', '扩展…', 2, 'expand');
  register('select.modify.contract', '收缩…', 3, 'contract');
  register('select.modify.feather', '羽化…', 4, 'feather');
}
